import { useState } from "react";
import { Grid, Paper, Typography } from "@mui/material";
import { formatMoney, formatValue } from "./Utils";
import ScrapedListings from "./ScrapedListings";

export default function LocationInformation(props) {
  const t = props.estatedProperty;
  const [map, setMap] = useState(null);
  if (!map) {
    new Promise((resolve) => {
      if (window.google) {
        return resolve(window.google);
      }
      const script = document.createElement("script");
      const key = process.env.REACT_APP_GOOGLE_STREET_KEY;
      script.src = `https://maps.googleapis.com/maps/api/js?key=${key}&libraries=geometry`;
      script.onload = () => resolve(window.google);
      document.getElementsByTagName("head")[0].appendChild(script);
    }).then((google) => {
      const position = { lat: t.address.latitude, lng: t.address.longitude };
      const map = new google.maps.Map(document.getElementById("map"), {
        center: position,
        zoom: 16,
      });
      const marker = new google.maps.Marker({ position, map });
      const panorama = new google.maps.StreetViewPanorama(
        document.getElementById("pano"),
        { position }
      );
      map.setStreetView(panorama);
      google.maps.event.addListener(panorama, "position_changed", () => {
        const heading = google.maps.geometry.spherical.computeHeading(
          panorama.getPosition(),
          marker.getPosition()
        );
        panorama.setPov({ heading, pitch: 0 });
      });
      setMap(map);
    });
  }

  const imgStyle = { width: "100%", height: "350px", borderRadius: 5 };
  return (
    <Paper sx={{ p: 2, display: "flex", flexDirection: "column" }}>
      <Typography variant="h6" color="primary" gutterBottom>
        Location Info
      </Typography>
      <Grid container spacing={2} justifyContent="space-between">
        <Grid item xs={4}>
          <div id="map" style={imgStyle}></div>
        </Grid>
        <Grid item xs={8}>
          <div id="pano" style={imgStyle}></div>
        </Grid>
        <Grid item xs={12}>
          <b>{t.address.formatted_street_address}</b>, {t.address.city},{" "}
          {t.address.state} {t.address.zip_code}
        </Grid>

        <Grid item textAlign="center">
          <Typography variant="h6">
            {formatMoney(t.estimatedReplacementCost)}
          </Typography>
          <Typography>Estimated RC</Typography>
        </Grid>
        <Grid item textAlign="center">
          <Typography variant="h6">{formatMoney(t.estimatedRent)}</Typography>
          <Typography>Est. Rent</Typography>
        </Grid>
        <Grid item textAlign="center">
          <Typography variant="h6">{formatMoney(t.estimatedTiv)}</Typography>
          <Typography>Est. TIV</Typography>
        </Grid>
        <Grid item textAlign="center">
          <Typography variant="h6">
            {formatValue(t.property_info.sqft)}
          </Typography>
          <Typography>Sq Ft</Typography>
        </Grid>
        <Grid item textAlign="center">
          <Typography variant="h6">{t.property_info.year_built}</Typography>
          <Typography>Year Built</Typography>
        </Grid>
        <Grid item textAlign="center">
          <Typography variant="h6">
            {formatMoney(
              Math.round(
                Math.min(
                  t.property_info.estimated_premium_2500,
                  t.property_info.estimated_premium_5000
                )
              )
            )}
          </Typography>
          <Typography>
            Premium Est.{" "}
            {t.property_info.estimated_premium_2500 <
            t.property_info.estimated_premium_5000
              ? "($2.5k Ded.)"
              : "($5k Ded.)"}
          </Typography>
        </Grid>
        <Grid item>
          <ScrapedListings {...props} />
        </Grid>
      </Grid>
    </Paper>
  );
}
